
// init
const utils               = require('../lib/utils')
const config              = require('../lib/config')
const clientBaseConfig    = require('./appConfig')

// has the config been initialized yet?
let configInitialized = false
const NODE_ENV = process.env.NODE_ENV || 'development'

config.setConfig = function(clientAppConfig, requireContexts){
    // prepare config if necessary
    if(configInitialized) return;
    configInitialized = true

    // prepare require contexts
    if(typeof(requireContexts) != 'undefined'){
        this.data.requireContexts.templates    = requireContexts.templates
        this.data.requireContexts.components   = requireContexts.components
        this.data.requireContexts.styles       = requireContexts.styles
    }

    // set config merge
    this.data.config = utils.simpleMerge(
        clientBaseConfig,
        ((clientBaseConfig || {}).envOverride || {})[NODE_ENV] || {},
        clientAppConfig || {},
        ((clientAppConfig || {}).envOverride || {})[NODE_ENV] || {},
    )

    // some config flags should not be merged but replaced instead.
    for(const nonMergerParentKey of ['language', 'media', 'environment']) {
        this.data.config[nonMergerParentKey] = {
            ...((clientBaseConfig || {})[nonMergerParentKey] || {}),
            ...((((clientBaseConfig || {}).envOverride || {})[NODE_ENV] || {})[nonMergerParentKey] || {}),
            ...((clientAppConfig || {})[nonMergerParentKey] || {}),
            ...((((clientAppConfig || {}).envOverride || {})[NODE_ENV] || {})[nonMergerParentKey] || {}),
        }
    }
    delete this.data.config.envOverride

	// init utils.moment
    // TODO: set via user langCode?
	utils.initMoment((this.data.config || {}).momentConfig || {})

    return (globalThis.appConfig = this.getConfig())
};

module.exports = config;
